<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/bgEYvG/tc-custom/9781250086778.jpg?1724535926088" alt="This image is the cover for the book Buckle and Squash: The Gigantic Giant Goof-up"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Buckle and Squash: The Gigantic Giant Goof-up
      </h1>
      <p class="bookDescription body article font2">
        <p><b>Once upon a time, on the Old Tumbledown Farm, in The Middle of Nowhere, in the Forgotten Corner of the Kingdom, two sisters are <i>still</i> arguing over their destinies. </b>Sadly, neither of their plans are really working. Eliza's archery skills are dangerous to everything <i>but </i>the target, and her trusty steed is merely their goat, Gertrude. Meanwhile, a sudden rash of royal weddings has sabotaged Lavender's plan to marry a prince.<br/><br/>Obviously, magic is the only answer. One rash Thumbelina-inspired wish on a magical snail later, and the Old Tumbledown Farm is suddenly a giant's birthday present-and this giant is <i>not</i> willing to let go of her new toys. Can Eliza and Lavender actually work together to come up with a cunning escape plan or will Lavender be too distracted by the sudden appearance of a handsome prince?<br/><br/>Hold on to your socks (or Gertrude will eat them!) as author Sarah Courtauld delivers everything fans of fractured fairytales could want from magic and princes to battling giants and cantankerous goats in <i>Buckle and Squash!</i></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Sarah Courtauld
      </h2>
      
      <p class="authorDescription body article"><B>Sarah Courtauld</B> won the Funny Women Comedy Writing Award in 2012 and the BAFTA/Rocliffe New Writing Forum 2012, judged by a panel including Jennifer Saunders and Chris Addison. She also does stand-up and improv, as well as working part-time as a writer for Usborne Children's Books. Her debut novel, <I>Buckle and Squash: The Perilous Princess Plot,</I> won the Sainsbury's Children's Book Award for Fiction Ages 5-9.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Feiwel and Friends
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?692412b7